import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
import {NavLink, useHistory} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from 'semantic-ui-react';

import deniedImg from '../assets/il-access-denied.png';
import deniedImg2x from '../assets/il-access-denied@2x.png';
import {isInIframe} from '../util/window';
import EmptyWatermark from './EmptyWatermark';
import {LoginButton, SignupButton} from './LoginButton';

interface AccessDeniedProps {
  unrecoverable?: boolean;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({unrecoverable}) => {
  const history = useHistory();
  // TODO: it would be nice to automatically reload the page after login
  return (
    <div style={{margin: '30px auto', maxWidth: 480}}>
      <EmptyWatermark
        imageSource={deniedImg}
        imageSource2x={deniedImg2x}
        header="Access Denied"
        details={
          unrecoverable
            ? 'This page can not be accessed from within an iframe'
            : undefined
        }
      />
      {!unrecoverable && (
        <div style={{textAlign: 'center'}}>
          <LoginButton size="small" />
          <SignupButton
            hideIcon
            target={isInIframe() ? '_blank' : '_self'}
            size="small"
          />
          <div style={{marginTop: 10, color: '#757575'}}>
            {isInIframe() ? (
              <>
                Already logged in?{' '}
                <a href="#refresh" onClick={() => history.go(0)}>
                  <Icon name="reload-refresh" /> Refresh
                </a>
              </>
            ) : (
              <NavLink to={`/`}>
                <Button primary>Home</Button>
              </NavLink>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AccessDenied;
